import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

import Snackbar from "@material-ui/core/Snackbar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import DialogContent from "@material-ui/core/DialogContent";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import { CopyToClipboard } from "react-copy-to-clipboard";

import { red } from "@material-ui/core/colors";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MovingText from "react-moving-text";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CircularProgress from "@material-ui/core/CircularProgress";

import TableCell from "@material-ui/core/TableCell";

import TableRow from "@material-ui/core/TableRow";

import { Alert } from "@material-ui/lab";

import Dialog from "@material-ui/core/Dialog";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";


import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";

import LinearProgress from "@material-ui/core/LinearProgress";


import Avatar from "@material-ui/core/Avatar";
import * as memberActions from "redux/member/action";
import * as yup from "yup";
import moment from "moment";

import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

import * as uiActions from "redux/ui/action";
import useFetch from "lib/useFetch";
import { API_URL, addCommas } from "modules/configApp";
import { useState } from "react";

const QRCode = require("qrcode.react");


export function getBase64(file, cb) {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    cb(reader.result);
  };
  reader.onerror = function (error) {
    //console.log('Error: ', error);
  };
}

export function decodeBase64Image(base64Str) {
  var matches = base64Str.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);
  var image = {};
  if (!matches || matches.length !== 3) {
    throw new Error("Invalid base64 string");
  }

  image.type = matches[1];
  image.data = matches[2];

  return image;
}

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ color: "#9f1f14" }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}


LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    background: "transparent",
    flexGrow: 1,
  },
  img: {
    flexGrow: 1,
  },
  top10: {
    paddingTop: 100,
  },
  rootCard: {
    maxWidth: 345,
  },
  rootbg: {
    backgroundColor: "#fff",
  },
  rootbody: {
    background: "#fff",
    flexGrow: 1,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  rootLoading: {
    zIndex: 10,
    top: 150,
    position: "absolute",
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
  headpaper: {
    backgroundColor: "#999695",
    padding: theme.spacing(2),
    textAlign: "center",
  },
  btn: {
    color: "#e08c09",
    borderColor: "#45351d",
  },
  appBar: {
    position: "relative",
    backgroundColor: "#3a78c2",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: "#fff",
    fontSize: 16,
  },
  formalert: {
    background: "transparent",
    fontSize: 16,
    color: "#000",
  },
  formalertbank: {
    fontSize: 16,
    backgroundColor: "#ddd",
  },
  rootbuttom: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    backgroundColor: "#000",
    opacity: 0.9,
  },
  rootbuttomload: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    opacity: 0.9,
  },
  confirm: {
    backgroundColor: "#fff",
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitleC = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default function FullWidthTabs(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [credit, setCredit] = React.useState(0);
  const { register, handleSubmit, errors } = useForm({
    mode: "onBlur",
    validationSchema: yup.object().shape({
      credit: yup.string().required(),
    }),
    //validationSchema:
    /*
    validationSchema:yup.object.shape({
      UserName:yup.string().required(),
      password:yup.string().required()
    })
    */
  });

  const dispatch = useDispatch();


  const {
    isLoading,
    item,
    items,
    wait,
    depositcomplete,
    showbox,
    showrun,
    lineid,
  } = useSelector((store) => store.member);
  const { notify } = useSelector((store) => store.ui);

  const [values, setValues] = React.useState(null);

  const [nstart, setnstart] = React.useState(false);
  const [showbonus, setShowbonus] = React.useState(false);


  const DelBooking = () => {
    const action = memberActions.DelBooking();
    dispatch(action);
  };


  
const [depositerr, setdepositerr] = React.useState(false);

  const handleClosedepositerr = () => {
    setdepositerr(false);
  };


  const [bonusdetail, setbonusdetail] = useState({})

  const submit = ({ credit }) => {
   
      if (parseFloat(credit) < parseFloat(10)) {
        setdepositerr(true);
      } else {
         const dataSave = {
      credit,
      lineid:lineid,
      promotion: bonusdetail,
    };
    setsubmitdisabled(true);
    setValues(1);
    const action = memberActions.Booking({ ...dataSave, ...props });
    dispatch(action);

    const liff = window.liff;
    liff.closeWindow();

      }
    
  };


  const [open, setOpen] = React.useState(false);
  const [openp, setOpenp] = React.useState(false);
  const [openc, setOpenc] = React.useState(false);
  const [submitdisabled, setsubmitdisabled] = React.useState(false);
  const handleClosewait = () => {
    //setshownot(false);
    setnstart(false);
    const action = uiActions.clearNotify();
    dispatch(action);
    const actionmember = memberActions.clearNotify();
    dispatch(actionmember);
    props.history.push("/dashboard");
  };
  const handleClosesuccess = () => {
    setShowbonus(false);
    const action = uiActions.clearNotify();
    //dispatch(action);
    const actionmember = memberActions.clearNotify();
    //dispatch(actionmember);
    //props.history.push("/dashboard");
  };

  const handleClose = () => {
    //setOpen(false);
    handleClickOpenp(true);
  };
  const handleCloseC = () => {
    //setOpen(false);
    setOpenc(false);
  };

  const handleClickOpenp = () => {
    setOpenp(true);
  };

  const handleClosep = () => {
    setOpenp(false);
  };
  const handleCloseYesp = () => {
    if ((nstart || wait) && !depositcomplete && !showrun) {
      setopenerror(true);
      handleCloseNotp();
    } else if (showrun) {
      setopenerror(true);
      handleCloseNotp();
    } else {
      setOpenp(false);
      setOpen(false);
      setsubmitdisabled(false);
      clearInterval();
      DelBooking();
    }
  };
  const handleCloseYesc = () => {
    setOpenc(false);
    submitBook();
  };

  const handleCloseNotp = () => {
    setOpenp(false);
  };

  const [openerror2, setopenerror2] = useState(false)
 


  const submitBook = () => {
    setnstart(true);
      const action = memberActions.BookingConfirmNew({ ...props });
      dispatch(action);
   
  };


  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const [value, setValue] = React.useState("1");

  const [newmember, setnewmember] = useState(0);
  

  const promotion = useFetch("https://apiadminbetg.com/promotion/listbunus?webtoken=sswinbet", {}, "get");
  const checkpromotion = useFetch(
    API_URL + "/booking/1/checkpromotion",
    {},
    "get"
  );

  const [turnover, setturnover] = React.useState(0);
  const [bonus, setbonus] = React.useState(0);
  const [pbonus, setpbonus] = React.useState(0);
  const [pmax, setpmax] = React.useState(0);
  const [pturn, setpturn] = React.useState(0);
  const btnSubmit = React.useRef(null);
  const setCreditNew = (credit) => {
    let nvalue = value;
    if (checkpromotion?.turnoverstatus == 1) {
      nvalue = checkpromotion?.promotionid;
    }
    let data = null;
    if (newmember == 1) {
      data = checkpromotion?.datapromotion;
    } else {
      data = promotion.items.find((x) => x._id == nvalue);
    }

    if (data) {
      const { pbonus, pmax, pmin, pturn } = data;
      let newbunus = (parseFloat(credit) * parseFloat(pbonus)) / 100;
      if (parseFloat(newbunus) > parseFloat(pmax)) {
        newbunus = pmax;
      }
      // เช็คว่าฝากมากกว่าเงื่อนไขหรือไม่
      if (parseFloat(credit) >= parseFloat(pmin)) {
        const turnover =
          (parseFloat(newbunus) + parseFloat(credit)) * parseFloat(pturn);
        setturnover(turnover);
        setbonus(newbunus);
        setpbonus(pbonus);
        setpmax(pmax);
        setpturn(pturn);
        //parseFloat(newbunus);
        // turnover;
      } else {
        setturnover(0);
        setbonus(0);
      }
    }
    //console.log("promotion", aaa);
    setCredit(credit);
    setbonusdetail({})
  };

  const setCreditNew2 = (credit) => {
    if (credit.target.value > 0) {
      setCreditNew(credit.target.value);
    } else {
      setCreditNew(0);
    }
  };

  //console.log("checkpromotion", checkpromotion);
  const goBack = (path) => {
    props.history.push(path);
  };

  const submit2 = () => {
    btnSubmit.current.click();
  };

  const [openerror, setopenerror] = React.useState(false);

  const handleCloseState = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setopenerror(false);
  };
 
  const selectbonus = (x) => {
    let newbonus = credit * x.pbonus
    if(parseFloat(newbonus) > parseFloat(x.pmax)) {
        newbonus = x.pmax
    }
    const allbonys = {
        bonus:newbonus,
        deposit:credit,
        feecredit:parseFloat(newbonus)+credit,
        pturnamount:x.pturnamount,
        pwithdrawamount:x.pwithdrawamount,
        id:x.id
    }
    setbonusdetail(allbonys)
    setShowbonus(false);
  }

  return (
    <>
      
      <Container
        maxWidth="md"
        style={{
          paddingTop: 20,
          display: "flex",
          flexDirection: "row",
          justifyContent: "left",
        }}
      >
        <Button
          color="primary"
          startIcon={<ArrowBackIosIcon />}
          variant="outlined"
          onClick={() => goBack("/")}
          className="btnback"
        >
          ย้อนกลับ
        </Button>
      </Container>
      {!nstart && !wait && (
        <Container
          maxWidth="md"
          style={{
            paddingTop: 20,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Card className={classes.root}>
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="h5"
                className="headtitle"
              >
                ฝากเงิน
              </Typography>
             
              <div style={{ height: 10 }}></div>
              (สำหรับกระเป๋าเงิน กีฬา/คาสิโน/สล๊อต)
              <div style={{ height: 10 }}></div>
                <Alert severity="warning">
               
                ใส่ยอดเงินเพื่อขอรับ QR Code สำหรับสแกนจ่าย รองรับ โมบายแบงก์กิ้ง/ทรูมันนี่วอลเล็ท
                </Alert>
              <div style={{ height: 10 }}></div>
              
              <form
                className={classes.form}
                noValidate
                onSubmit={handleSubmit(submit)}
              >
                <input
                  ref={register}
                  type="text"
                  id="credit"
                  name="credit"
                  class="form__input"
                  placeholder={`ขั้นต่ำ ${
                    items?.agent?.mindeposit || 10
                  } บาท`}
                  value={credit ? credit : null}
                  onChange={setCreditNew2}
                />

                <Grid container spacing={1} style={{ paddingTop: 20 }}>
                  <Grid item xs={4} sm={4}>
                    <div className="btnnew" onClick={() => setCreditNew(100)}>
                      100
                    </div>
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <div className="btnnew" onClick={() => setCreditNew(300)}>
                      300
                    </div>
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <div className="btnnew" onClick={() => setCreditNew(500)}>
                      500
                    </div>
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <div className="btnnew" onClick={() => setCreditNew(1000)}>
                      1,000
                    </div>
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <div className="btnnew" onClick={() => setCreditNew(3000)}>
                      3,000
                    </div>
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <div className="btnnew" onClick={() => setCreditNew(5000)}>
                      5,000
                    </div>
                  </Grid>
                </Grid>
                <div style={{ height: 10 }}></div>
               
                <div style={{ height: 2 }}></div>
                <div style={{ height: 10 }}></div>
                {
                    promotion && credit>0 && promotion?.items?.length > 0 && !bonusdetail?.feecredit &&  <div>
                    ต้องการฟรีโบนัส คลิก  <span className="btnnewbonus" onClick={() => setShowbonus(true)}>
                          รับโบนัส
                        </span>
                   </div>
                }
                {
                    bonusdetail?.feecredit > 0 &&  <div>
                    ต้องการยกเลิกโบนัส คลิก <span className="btnnewbonus" onClick={() => setbonusdetail({})}>ไม่รับโบนัส</span>
                   </div>
                }
                {
                    bonusdetail?.feecredit > 0 && <div>
                    <Alert severity="info">
                   
                   รับเครดิตรวมเป็น :  {
                        addCommas(parseFloat(bonusdetail?.feecredit).toFixed(0))
                    } บาท
                   </Alert>
                   <div className="btnnewbonus">
                   เงื่อนไขถอน 
                   </div>
                   <ul className="press">
                    <li><div className="btnnewbonus">ทำยอด :  {
                        addCommas(parseFloat(bonusdetail?.pturnamount).toFixed(0))
                    } เครดิต </div></li>
                     <li><div className="btnnewbonus">ถอนได้ :  {
                        addCommas(parseFloat(bonusdetail?.pwithdrawamount).toFixed(0))
                    } เครดิต </div></li>
                   </ul>
                   <Alert severity="warning">
                      ทำเงื่อนไขให้ครบลูกค้าถึงจะถอนเงินออกได้
                   </Alert>
                   </div>
                }
                
               
              <div style={{ height: 10 }}></div>
                <div style={{ height: 10 }}></div>
                {
                    credit > 10 && <div className="btnsubmit" onClick={submit2}>
                    ขอ QRCode สำหรับสแกนจ่าย
                    </div>
                }
                
               
                <button
                  type="submit"
                  ref={btnSubmit}
                  className="btnnone"
                ></button>
              </form>
              <div style={{ height: 100 }}></div>
            </CardContent>
          </Card>
          {isLoading && (
            <div className={classes.rootLoading}>
              <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          )}
        </Container>
      )}

      <Dialog
        open={showbonus}
        onClose={handleClosesuccess}
        //aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        aria-labelledby="customized-dialog-title"
      >
        <DialogTitleC id="alert-dialog-title" onClose={handleClosesuccess}>
          {"เลือกโบนัส"}
        </DialogTitleC>
        <DialogContent style={{ textAlign: "center" }}>
            <div className="mgboby">
          <ul className="press">
            {
                promotion && promotion?.items && promotion?.items.map(x=> <li key={x.id} onClick={()=> selectbonus(x)}><div className="btnnewbonusx">{x.name}</div></li>)
            }
            
          </ul>
          </div>
        </DialogContent>
        <DialogActions style={{ textAlign: "center" }}></DialogActions>
      </Dialog>

      <Snackbar
        open={openerror2}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={6000}
        onClose={() => setopenerror2(false)}
      >
        <Alert onClose={() => setopenerror2(false)} severity="error">
        กรุณาแนบสลิปโอนด้วยค่ะ
        </Alert>
      </Snackbar>

      <Snackbar
        open={openerror}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={6000}
        onClose={handleCloseState}
      >
        <Alert onClose={handleCloseState} severity="error">
          ขออภัยค่ะ ไม่สามารถยกเลิกรายการฝากได้ จนกว่าจะหมดเวลา
        </Alert>
      </Snackbar>

      <Dialog
        open={depositerr}
        onClose={handleClosedepositerr}
        //aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        aria-labelledby="customized-dialog-title"
      >
        <DialogTitleC id="alert-dialog-title" onClose={handleClosedepositerr}>
          {"ใส่จำนวนเงิน"}
        </DialogTitleC>
        <DialogContent style={{ textAlign: "center" }}>
          <div>
            {/*<img src="/images/compelet.png" height="50"></img>*/}
            <img src="/images/error.png" height="50"></img>
          </div>
          {/*<div>ยอดเงินของคุณได้รับการยืนยันแล้วค่ะ</div>*/}
          <div>ใส่ยอดเงินขั้นต่ำ {items?.agent?.mindeposit} บาท</div>
        </DialogContent>
        <DialogActions style={{ textAlign: "center" }}></DialogActions>
      </Dialog>
    </>
  );
}
